import { fetchMonitorDataSuccess } from 'modules/monitor/actions';

export const monitorDependencies = ({ dispatch, value, section, auxData }) => {
	const items = (auxData.length && auxData) || value;
	dispatch(fetchMonitorDataSuccess(items, section));
};
